import { cookieStorage } from '../storage/cookie-storage';

export enum PrivacyPolicyStatus {
    ACCEPTED = 'accepted',
    REJECTED = 'rejected',
}

class PrivacyPolicyService {
    public acceptPolicy(): void {
        cookieStorage.setItem('privacyPolicy', PrivacyPolicyStatus.ACCEPTED, 365);
    }

    public getStatus(): string | boolean {
        return cookieStorage.getItem('privacyPolicy');
    }
}

export const privacyPolicyService = new PrivacyPolicyService();
